export default __webpack_public_path__ + "static/media/hessahStore8.d0382732.jpg";